import Flickity from 'flickity';

export default {
  init($element) {

  },
  finalize($element) {
    function checkTableOverflow() {
      if ($element.find('.table-wrap').get()[0].scrollWidth > $element.find('.table-wrap').width()) {
        
        // Table overflows, make it a carousel.
        const tableCarousel = new Flickity($element.find('.table-carousel').get()[0], {
          prevNextButtons: false,
          pageDots: false,
          contain: true,
          cellAlign: 'left',
          draggable: '>0',
          freeScroll: true,
          freeScrollFriction: 1,
          friction: 1,
          selectedAttraction: 0.1,
        });

        // Customised scrollbar. This can surely be improved?
        const cellWidth = $element.find('.flickity-slider .carousel-cell:first-of-type').innerWidth();

        const $container = $element.find('> .container');
        const containerWidth = $container.innerWidth() - parseInt($container.css('padding-left')) - parseInt($container.css('padding-right'));

        const $scrollbarWrap = $element.find('.scrollbar-wrap');
        const $scrollbarInner = $scrollbarWrap.find('.scrollbar-inner');

        $scrollbarWrap.removeClass('d-none');

        const scrollbarWidth = (containerWidth / cellWidth) * 100;
        $scrollbarInner.css('width', scrollbarWidth + '%');

        const maxLeft = 100 - scrollbarWidth;

        tableCarousel.on('scroll', function(e, progress) {
          const progressPercentage = (progress / (cellWidth - containerWidth)) * 100;

          let progressOffset = (progressPercentage / 100) * maxLeft;

          if (progressOffset < 0) {
            progressOffset = 0;
          }

          if (progressOffset > maxLeft) {
            progressOffset = maxLeft;
          }

          $scrollbarInner.css('left', progressOffset + '%');
        });
      }
    }

    checkTableOverflow();
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/flexible/table.js